<template>
    <transition name="follow-fans-fade">
        <div
            v-if="visible"
            class="agpNofansW"
            @click.self="close"
            @touchmove.stop.prevent
        >
            <div class="agpNofansBox">
                <div class="agpNofansImg">
                    <img :src="info.avatar || ''" alt="">
                </div>
                <p>是否关注“{{ info.nickname || '' }}”查看仅粉丝可见内容？</p>
                <div
                    :class="['agpNofansBtn', { loading }]"
                    @click.stop.prevent="confirm"
                >{{ loading ? '关注中...' : '立即关注' }}</div>
                <div class="agpNofansBtn closeBtn" @click.stop.prevent="close">暂不</div>
            </div>
        </div>
    </transition>
</template>

<script>
import { FollowFansDialog } from '@/utils/followFansDialog'
import userHomeApi from '@/api/user_home/index.js'
import { Toast } from 'vant'
import { isLoginInfo } from '@/utils/index'

export default {
    name: 'FollowFansDialog',
    data() {
        return {
            visible: false,
            loading: false,
            info: {}
        }
    },
    created() {
        FollowFansDialog.onShow(this.onShow)
        FollowFansDialog.onHide(this.onHide)
    },
    beforeDestroy() {
        FollowFansDialog.offShow(this.onShow)
        FollowFansDialog.offHide(this.onHide)
    },
    methods: {
        onShow(payload = {}) {
            this.info = payload
            this.loading = false
            this.visible = true
        },
        onHide() {
            this.close()
        },
        close() {
            this.visible = false
            this.loading = false
        },
        async confirm() {
            if (!isLoginInfo()) return
            if (this.loading) return

            const targetId = this.info.l_id
            if (!targetId) {
                Toast('用户信息缺失')
                return
            }

            this.loading = true
            try {
                const res = await userHomeApi.setFollowLive({
                    id: targetId,
                    act: 'follow'
                })
                if (res && res.rslt === 'succ') {
                    Toast.success('关注成功')
                    // 先关闭弹窗，再执行回调，保证 UI 响应更快
                    this.close()
                    // 广播关注成功事件，供 user_home 等页面同步状态
                    FollowFansDialog.followSuccess({ l_id: targetId })
                    if (typeof this.info.onSuccess === 'function') {
                        this.info.onSuccess({ l_id: targetId })
                    }
                } else {
                    Toast((res && res.msg) || '关注失败，请稍后重试')
                }
            } catch (error) {
                Toast('关注失败，请稍后重试')
            } finally {
                this.loading = false
            }
        }
    }
}
</script>

<style scoped lang="scss">
.follow-fans-fade-enter-active,
.follow-fans-fade-leave-active {
    transition: opacity .25s ease;
}
.follow-fans-fade-enter,
.follow-fans-fade-leave-to {
    opacity: 0;
}

.agpNofansW {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.6);

    .agpNofansBox {
        width: 280px;
        min-height: 240px;
        border-radius: 8px;
        background: #fff;
        position: relative;
        overflow: visible;
        padding-bottom: 24px;

        .agpNofansImg {
            border: 5px solid #fff;
            border-radius: 50%;
            width: 80px;
            height: 80px;
            position: absolute;
            left: 50%;
            top: -12%;
            transform: translateX(-50%);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            overflow: hidden;
            background: #f5f5f5;

            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                object-fit: cover;
            }
        }

        p {
            margin: 70px 30px 0;
            font-size: 16px;
            line-height: 160%;
            font-weight: bold;
            text-align: center;
            color: #333;
        }

        .agpNofansBtn {
            margin: 20px auto 0;
            cursor: pointer;
            width: 200px;
            height: 42px;
            border-radius: 4px;
            box-sizing: border-box;
            background: #EE494D;
            color: #fff;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            user-select: none;

            &.loading {
                opacity: 0.7;
            }

            &.closeBtn {
                border: 1px solid #DDDDDD;
                background: #fff;
                color: #333;
                margin-top: 12px;
            }
        }
    }
}
</style>
